import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { IconStar } from '@tabler/icons';
import { getAllData } from '../../redux/actions/api/GetAllData';
import Breadcrumb from '../../components/breadcrumb/Breadcrumb';
import Loading from '../../components/loading/Loading';

export default function Hero() {
  const dispatch = useDispatch();
  const { accessToken } = useSelector((state) => state?.auth);
  const { data: hero, loading, error } = useSelector((state) => state?.api);
  useEffect(() => {
    dispatch(getAllData('hero', accessToken));
  }, [accessToken, dispatch]);
  return (
    <>
      <Breadcrumb
        url='/hero/edit'
        title='All information about hero'
        textActive='Hero'
        btnText='Edit Hero'
      />
      {loading ? (
        <Loading isLoading={loading} />
      ) : error ? (
        error
      ) : (
        <div className='container-fluid'>
          <div className='row col-11 col-md-8 m-auto details-info card pe-0'>
            <div className='ribbon ribbon-top bg-yellow'>
              <IconStar />
            </div>
            <div className='row px-0'>
              <div className='col-md-12 py-4 border-bottom border-start border-end'>
                <div className='row px-0'>
                  <div className='col-md-4'>
                    <h3 className='title'>hero ar :</h3>
                  </div>
                  <div className='col-md-8'>
                    <h4 className='sub-title text-end'>{hero?.hero_ar}</h4>
                  </div>
                </div>
              </div>
              <div className='col-md-12 pt-4 border-start border-end border-bottom '>
                <div className='row'>
                  <div className='col-md-4'>
                    <h3 className='title'>hero en :</h3>
                  </div>
                  <div className='col-md-8'>
                    <h4 className='sub-title'>{hero?.hero_en}</h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
